<template>
    <footer class="footer bg-dark">
        <div class="row">
            <div class="col-12 col-md-6 text-center mb-3 mb-md-4 mb-lg-2">
                <div>{{ footerContent.createdBy }}: Eliahu García Lozano</div>
                <div class="social-media">
                    <a href="https://twitter.com/eligarlo" target="_blank"><img :src="require('@/assets/img/twitter.svg')" alt="twitter icon"></a>
                    <a href="https://www.instagram.com/eligarloz/" target="_blank"><img :src="require('@/assets/img/instagram.svg')" alt="instagram icon"></a>
                    <a href="https://www.facebook.com/eligarloz" target="_blank"><img :src="require('@/assets/img/facebook.svg')" alt="facebook icon"></a>
                </div>
            </div>

            <div class="col-12 col-md-6 text-center mb-3 mb-md-4 mb-lg-2">
                <div>{{ footerContent.contentBy }}: Shirel García Lozano</div>
                <div class="social-media">
                    <a href="https://www.instagram.com/shirel_92/" target="_blank"><img :src="require('@/assets/img/instagram.svg')" alt="instagram icon"></a>
                    <a href="https://www.facebook.com/lidia.jambrinasanchez.5" target="_blank"><img :src="require('@/assets/img/facebook.svg')" alt="facebook icon"></a>
                </div>
            </div>

            <div class="col-12 disclaimer">
                <small>© {{ getCurrentYear }}, García Lozano Family</small>
            </div>
        </div>
    </footer>
</template>

<script>
import store from '@/store';
export default {
    data() {
        return {
            footerContent: store.footer
        }
    },
    computed: {
        getCurrentYear() {
            return new Date().getFullYear();
        }
    }
}
</script>

<style scoped>
.footer {
    padding: 15px;
    color: #ffffff;
}

.social-media {
    margin-top: 10px;
}

img {
    max-width: 25px;
    margin-right: 10px;
}

.disclaimer {
    text-align: center;
}

@media only screen and (min-width: 768px){
    .footer {
        padding: 30px;
    }
}
</style>